import { c as _c } from "react/compiler-runtime";
import { StackedChainLogos, useChains } from "@opensea/app-kit";
import { Badge, FlexCenter, FlexColumn, TextBody, Tooltip } from "@opensea/ui-kit";
import { ChevronRight } from "@opensea/ui-kit/icons";
import { groupBy } from "es-toolkit/array";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { Button } from "../../../../../components/Button";
import { useConnect } from "../../../../../polychain/hooks";
import { ConnectModalState } from "../../../../../stores/connectModalStore";
export const SelectEcosystem = props => {
  const $ = _c(14);
  const t = useTranslations("wallet.SelectEcosystem");
  const {
    switchOnConnect,
    isLinking
  } = props;
  const {
    step
  } = useSnapshot(ConnectModalState);
  const {
    chains
  } = useChains();
  const chainsByArch = groupBy(chains, _temp);
  const getTitle = connector => {
    if (connector.chainArch === "EVM") {
      return t("title.evm", {
        count: chainsByArch.EVM.length - 1
      });
    }
    return t("title.solana");
  };
  const {
    connect
  } = useConnect(props);
  let t0;
  if ($[0] !== connect || $[1] !== switchOnConnect) {
    t0 = async connector_0 => {
      await connect(connector_0, {
        switchOnConnect
      });
    };
    $[0] = connect;
    $[1] = switchOnConnect;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onConnect = t0;
  if (step.id !== "select-ecosystem") {
    return null;
  }
  const T0 = FlexColumn;
  const t1 = "gap-6";
  let t2;
  if ($[3] !== t) {
    t2 = t("description");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <TextBody className="text-center" color="text-secondary" size="sm">{t2}</TextBody>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const T1 = FlexColumn;
  const t4 = "gap-2";
  const t5 = step.connectOption.connectors.map(connector_1 => <Tooltip className="max-w-[380px] text-center" content={t("connectedTooltip", {
    walletName: connector_1.name
  })} disabled={isLinking || !connector_1.isConnected()} key={connector_1.id}><div><Button className="w-full justify-between p-3" disabled={!isLinking && connector_1.isConnected()} key={connector_1.id} onClick={() => onConnect(connector_1)} size="lg" variant="tertiary"><FlexCenter className="gap-2"><StackedChainLogos chains={chainsByArch[connector_1.chainArch].map(_temp2)} limit={3} size="sm" /><TextBody size="sm">{getTitle(connector_1)}</TextBody></FlexCenter>{connector_1.isConnected() ? <Badge>{t("connected")}</Badge> : <ChevronRight size={20} />}</Button></div></Tooltip>);
  let t6;
  if ($[7] !== T1 || $[8] !== t5) {
    t6 = <T1 className={t4}>{t5}</T1>;
    $[7] = T1;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== T0 || $[11] !== t3 || $[12] !== t6) {
    t7 = <T0 className={t1}>{t3}{t6}</T0>;
    $[10] = T0;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
function _temp(c) {
  return c.arch;
}
function _temp2(chain) {
  return chain.identifier;
}